<template>
	<div v-if="loaded" :data-key="settings.key">
		<header class="c-listing__header">
			<h2 class="c-listing__heading">{{this.settings.heading}}</h2>
		</header>

		<div id="js-filters" v-if="this.filters.filters">
			<!--<button type="button" @click="isActive = !isActive" class="c-filters-toggler mobile-only" aria-label="Show Filters">Show Filters</button>-->
			<button type="button"
					data-flyout-toggle="filter"
					class="c-filters-toggler mobile-only"
					aria-label="Show Filters">
				Show Filters
			</button>

			<filters :filters="this.filters"
					 :filter-is-showing="filtersActive"
					 @filters-changed="onFiltersChanged"
					 @toggle-filters="filtersActive = !filtersActive" />
		</div>

		<ul class="c-listing-list" v-if="paginatedListing.length">
			<li class="c-listing-list__item c-listing-list-item" v-for="(listItem) in paginatedListing" :key="listItem.id">

				<component :is="listItem.link?.url ? 'a' : 'div'"
						   :href="listItem.link?.url || null"
						   :title="listItem.link?.name || null"
						   class="c-listing-list-item__link"
						   :data-categories="listItem.categories ? listItem.categories.map(c => c.id).join(',') : ''">

					<div class="c-listing-list-item__figure">
						<img v-if="listItem.image && listItem.image.cropUrl"
							 :src="baseUrl + listItem.image.cropUrl"
							 :alt="listItem.image.altText || ''"
							 class="c-listing-list-item__image"
							 loading="lazy" />
						<img v-else
							 class="c-listing-list-item__image c-listing-list-item__image--placeholder"
							 src="/Content/images/interface/logo/buddlefindlay-logo.svg"
							 :alt="listItem.title" />
					</div>
					<div class="c-listing-list-item__body">
						<div v-if="listItem.categories" class="c-listing-list-item__categories">
							<span class="c-listing-list-item__category" v-for="category in listItem.categories" v-bind:key="category" >
								{{ category.name }}
							</span>
						</div>
						<h3 class="c-listing-list-item__heading">{{ listItem.title}} </h3>
						<p class="c-listing-list-item__text" v-if="listItem.abstract">{{ listItem.abstract }}</p>
					</div>
				</component>

			</li>
		</ul>

		<p class="c-listing__heading" v-else>{{this.settings.noResultsMessage}}</p>

		<pagination v-if="filteredListing.length > pageSize"
					:total-items="filteredListing.length"
					:page-size="pageSize"
					:current-page="currentPage"
					@page-changed="onPageChanged" />
	</div>

</template>


<script>
	export default {
		name: 'listingModule',
		props: {
			settings: {
				type: Object,
				required: true
			},
			listingApi: {
				type: String,
				required: true
			},
			refId: {
				type: [String, Number],
				required: true
			}
		},
		data() {
			return {
				loaded: false,
				listing: null,
				filters: null,
				selectedFilters: [],
				filtersTouched: false,
				filtersActive: false,
				currentPage: 1,
				pageSize: 12,
			};
		},
		mounted() {
			const baseUrl = window.location.origin;
			fetch(baseUrl + this.listingApi).then(res => res.json()).then(response => {
				this.listing = response.items || [];
				this.filters = response.filterView || {};
				this.loaded = true;

				// Restore filters from localStorage
				const savedFilters = JSON.parse(localStorage.getItem('listing-filters') || '[]');
				if (savedFilters.length && this.filters && this.filters.filters) {
					this.filters.filters.forEach(filter => {
						(filter.filterOptions || []).forEach(option => {
							option.selected = savedFilters.includes(option.id);
						});
					});
					this.selectedFilters = savedFilters;
					this.filtersTouched = true;
				}
			}).catch(() => {
				this.listing = [];
			});
		},
		computed: {
			baseUrl() {
				return window.location.origin;
			},
			selectedFiltersByGroup() {
				const map = {};
				if (!this.filters || !this.filters.filters) return map;
				this.filters.filters.forEach(filter => {
					const selected = (filter.filterOptions || []).filter(opt => opt.selected).map(opt => opt.id);
					if (selected.length) {
						map[filter.name] = selected;
					}
				});
				return map;
			},
			filteredListing() {
				if (!this.filtersTouched || !this.selectedFilters.length) return this.listing || [];
				const selectedByGroup = this.selectedFiltersByGroup;
				const groupNames = Object.keys(selectedByGroup);
				if (groupNames.length === 0) return this.listing || [];
				if (groupNames.length === 1) {
					// Only one group: 'or' logic
					const selectedIds = selectedByGroup[groupNames[0]];
					return (this.listing || []).filter(item => {
						if (!item.categories) return false;
						return item.categories.some(cat => selectedIds.includes(cat.id));
					});
				} else {
					// Multiple groups: 'and' logic between groups, 'or' within group
					return (this.listing || []).filter(item => {
						if (!item.categories) return false;
						return groupNames.every(groupName => {
							const selectedIds = selectedByGroup[groupName];
							return item.categories.some(cat => selectedIds.includes(cat.id));
						});
					});
				}
			},
			paginatedListing() {
				const start = (this.currentPage - 1) * this.pageSize;
				const end = start + this.pageSize;
				return this.filteredListing.slice(start, end);
			}
		},

		methods: {
			onFiltersChanged(selected) {
				this.selectedFilters = selected;
				this.filtersTouched = true;
				this.currentPage = 1; // Reset to first page on filter change
				localStorage.setItem('listing-filters', JSON.stringify(selected));
			},
			onPageChanged(page) {
				this.currentPage = page;
				const offset = 100; // Adjust for sticky header height
				const elementPosition = this.$el.getBoundingClientRect().top + window.pageYOffset;
				window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
			},

		},

	};

</script>